import { CHANGE_STYLE_SUCCESS, CLOSE_DETAIL_EVAL_SUCCESS, EXPORT_PDF_DETAIL_EVAL_SUCCESS,CHANGE_STATUS_SUCCESS,CHANGE_STATUS_FAIL, OPEN_DETAIL_EVAL_SUCCESS,CHANGE_SELECTEDTAB2_SUCESS,CHANGE_TAB3_SUCESS,CHANGE_TAB4_SUCESS,CHANGE_SELECTEDTAB_SUCESS, CHANGE_SCORE_SUCESS,OPEN_DETAIL_GRILLE_SUCCESS,CLOSE_DETAIL_GRILLE_SUCCESS,CHANGE_TAB2_SUCESS, CHANGE_TAB_SUCESS,CHANGE_TAB_FILTER_LIST_SUCESS} from "./type"

  export const changeStyle = (isOpen, pageNumber, prevPage) => {
    return {
      type: CHANGE_STYLE_SUCCESS,
      payload: {isOpen, pageNumber, prevPage}
    }
  }

  export const openDetailEval = () => {
    return {
      type: OPEN_DETAIL_EVAL_SUCCESS,
      payload: true
    }
  }
  export const activerChangeStatus = (status) => {

    return {
      type: CHANGE_STATUS_SUCCESS,
      payload: {status}
    }
  }

  export const exportPdfDetailEval = (exportpdf) => {
    return {
      type: EXPORT_PDF_DETAIL_EVAL_SUCCESS,
      payload:{ exportpdf}
    }
  }

  export const closeDetailEval = () => {
    return {
      type: CLOSE_DETAIL_EVAL_SUCCESS,
      payload: false,
    }
  }
  
  export const openDetailGrille = () => {
   
    return {
      type: OPEN_DETAIL_GRILLE_SUCCESS,
      payload: true,
    }
  }
  export const ChangeScore = (score) => {
  
    return {
      type: CHANGE_SCORE_SUCESS,
      payload: {score},
    }
  }
  export const Changetab = (tab) => {
   
    return {
      type: CHANGE_TAB_SUCESS,
      payload: {tab},
    }
  }
  export const Changetab2 = (tab2) => {
   
    return {
      type: CHANGE_TAB2_SUCESS,
      payload: {tab2},
    }
  }
  export const Changeselectetedtab = (selectedtab) => {
    
    return {
      type: CHANGE_SELECTEDTAB_SUCESS,
      payload: {selectedtab},
    }
  }
  export const Changeselectetedtab2 = (selectedtab2) => {
   
    return {
      type: CHANGE_SELECTEDTAB2_SUCESS,
      payload: {selectedtab2},
    }
  }
  export const Changetab3 = (tab3) => {
    
    return {
      type: CHANGE_TAB3_SUCESS,
      payload: {tab3},
    }
  }
  export const Changetab4 = (tab4) => {
    
    return {
      type: CHANGE_TAB4_SUCESS,
      payload: {tab4},
    }
  }

  export const ChangetabFilterList = (tabOptionsList) => {
    
    return {
      type: CHANGE_TAB_FILTER_LIST_SUCESS,
      payload: {tabOptionsList},
    }
  }
 
  export const closeDetailGrille = () => {
    return {
      type: CLOSE_DETAIL_GRILLE_SUCCESS,
      payload: false,
    }
  }
